module.exports = __webpack_public_path__ + "static/media/tribometro.666ca5cb.jpg";